// GLOBAL VARIABLES
let isTablet = 900 < innerWidth ? false : true;
let isMobile = 600 < innerWidth ? false : true;

window.addEventListener('resize', () => {
	isTablet = 900 < innerWidth ? false : true;
	isMobile = 600 < innerWidth ? false : true;
});

// OUTPUTS
const getQueryVariable = variable => {
	let query = window.location.search.substring(1);
	let vars = query.split("&");

	for (let i = 0; i < vars.length; i++) {
		let pair = vars[i].split("=");
		if (pair[0] == variable) { return pair[1]; }
	}
	return (false);
};

// ACTIONS
const scrollDisable = () => {
	root.style.overflow = 'hidden';
};

const scrollEnable = () => {
	root.style.overflow = 'initial';
};

// event delegation
// example; on('body', 'click', '.accordion-toggle, e => {…});
const on = (selector, eventType, childSelectors, eventHandler) => {
	childSelectors = childSelectors.split(',');
	let elements = document.querySelectorAll(selector);
	for (element of elements) {
		element.addEventListener(eventType, (eventOnElement) => {
			childSelectors.forEach((selector) => {
				if (
					eventOnElement.target.matches(selector) ||
					eventOnElement.target.closest(selector)
				) {
					eventHandler(eventOnElement);
				}
			});
		});
	}
};